import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { AuthorizationBase } from '../../../core/authorize-base';

@Component({
  selector: 'app-google-pay-button',
  templateUrl: './google-pay-button.component.html',
  styleUrls: ['./google-pay-button.component.scss'],
})
export class GooglePayButtonComponent
  extends AuthorizationBase
  implements OnInit
{
  @Input() amount: number = 10;
  @Input() gatewayMerchantId: string;
  @Input() googlePayMerchantId: string;
  @Input() canTokenize: boolean = true;
  @Output() tokenize = new EventEmitter<object>();

  buttonColor = 'white';
  buttonType: string = 'plain';
  buttonWidth = '100%';
  paymentRequest: any;
  paymentEnvironment: string = environment.googlePay.environment;
  currencyCode: string = 'USD';
  countryCode: string = 'US';
  totalPriceLabel: string;
  gateway: string = 'globalpayments';
  prodTestMerchants: string[] = ['v2prodtest', 'developerprod', 'v2demo'];
  isLoading: boolean = false;

  constructor(private apiService: ApiService) {
    super();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.apiService
      .get(`account/configuration/get?name=Sandbox.IsEnabled`)
      .subscribe(
        (response: any) => {
          this.paymentEnvironment =
            response.Value == 'TRUE' ? 'TEST' : 'PRODUCTION';

          this.isLoading = false;
          this.setConfiguration();
        },
        (error: any) => {
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  paymentDataCallback: (event: Object) => void = (event: Object): void => {
    this.tokenize.emit(event);
  };

  setAmount(amount: number): void {
    this.amount = amount;
  }

  setCanTokenize(canTokenize: boolean): void {
    this.canTokenize = canTokenize;
  }

  private setConfiguration(): void {
    this.gatewayMerchantId = this.gatewayMerchantId.substring(3);

    this.paymentRequest = {
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [
        {
          type: 'CARD',
          parameters: {
            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
            allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD', 'DISCOVER'],
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              gateway: this.gateway,
              gatewayMerchantId: this.gatewayMerchantId,
            },
          },
        },
      ],
      merchantInfo: {
        merchantName: this.gatewayMerchantId,
        merchantId: this.googlePayMerchantId,
      },
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPriceLabel: 'Total',
        totalPrice: this.amount.toString(),
        currencyCode: this.currencyCode,
        countryCode: this.countryCode,
      },
      emailRequired: true,
    };
  }
}
